import * as React from "react";
import {PropsWithChildren, useRef} from "react";
import {inject, observer} from "mobx-react";

import clipsFullscreenClasses from "../../ClipsFullscreen.styl";

import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";

import {useOnEnterViewport} from "@ok/web/components/base/hooks/useOnEnterViewport";
import {Direction} from "../../../../lib/types";
import {
    ADDITIONAL_TIME_DELAY_FOR_DELETE_NOT_ALLOWED_CLIP,
    INTERSECTION_OBSERVER_THRESHOLDS,
    SCROLL_ANIMATION_TIMING
} from "../../../../config";



interface IClipNotAllowedWrapper extends PropsWithChildren {
    store?: ClipsFullscreenStore
}
export const ClipNotAllowedWrapper: React.FC<IClipNotAllowedWrapper> = inject("store")(observer(
    (props) => {
        const store = props.store!;

        const timeout = useRef<ReturnType<typeof setTimeout>>();
        const rootRef = React.useRef<HTMLDivElement>(null);
        const [isShowedOnce, setIsShowedOnce] = React.useState(false);

        const { isEnterViewport } = useOnEnterViewport({
            ref: rootRef,
            threshold: INTERSECTION_OBSERVER_THRESHOLDS.CLIP_NOT_ALLOWED
        });


        React.useEffect(() => {
            if (isEnterViewport) {
                if (isShowedOnce) {
                    return;
                }

                if (store.currentItemIndex !== 0) {
                    let step;
                    if (store.scrollDirection === Direction.FORWARD) {
                        step = 1;
                    } else if (store.currentItemIndex === 0) {
                        step = 0;
                    } else {
                        step = -1;
                    }

                    store.setCurrentItemIndex(store.currentItemIndex + step);
                    store.updateCurrentFullscreenItems();
                }

                if (store.currentItemIndex === 0 && store.isAnimationRunning) {
                    store.setCurrentItemIndex(store.currentItemIndex + 1);
                    store.updateCurrentFullscreenItems();
                }

                store.setAnimateNotAllowedClip(true);
                store.startItemsListBouncingAnimation();

                store.indexToDeleteNotAllowed = store.currentItemIndex;

                setIsShowedOnce(true);

                store.checkOffset();
                store.setIsAnimationRunning(false);
            } else if (isShowedOnce) {
                timeout.current = setTimeout(() => {
                    store.removeNotAllowed();
                    store.setAnimateNotAllowedClip(false);
                }, Number(SCROLL_ANIMATION_TIMING.DEFAULT) * 1000 + ADDITIONAL_TIME_DELAY_FOR_DELETE_NOT_ALLOWED_CLIP);
            }

            return () => {
                if (timeout.current) {
                    clearTimeout(timeout.current);
                }
            };
        }, [isEnterViewport, isShowedOnce, store]);


        return (
            <div ref={rootRef} className={clipsFullscreenClasses["height100"]}>
                {props.children}
            </div>
        );
    })
);
